module.exports = __webpack_public_path__ + "static/media/private.699f272c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/private.png
// module id = 755
// module chunks = 0 1